export const parseDataValue = (value, parser) => {
    if (value === undefined || value === null || value === '') {
        return null;
    }

    const parsedValue = parser(value);

    return Number.isNaN(parsedValue) ? null : parsedValue;
};

export const defaultTooltipLabel = vm => context => ` ${vm.data.risks[context.dataIndex].percentageDisplay}%`;

export const intParser = value => parseInt(value, 10);
export const floatParser = value => parseFloat(value);